import { cloudChiprApi } from "@/services/cloudchipr.api";

export const getAiKubernetesRecommendationsEndpointSelector = (
  resourceId?: string,
) =>
  cloudChiprApi.endpoints.getOrganisationsCurrentSavingsOpportunitiesAi.select({
    resourceId,
  });
